<template>
    <v-layout wrap>
        <v-flex xs12 md6 class="pa-2">
            <slot name="first-column" />
        </v-flex>
        <v-flex xs12 md6 class="pa-2">
            <slot name="second-column" />
        </v-flex>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'TwoColumnDetailsPane',
})
export default class TwoColumnDetailsPane extends Vue {}
</script>
